import { AssetLogo, WithNAFallback } from '@toggle/design-system';
import { formatTicker, MappedEntity } from '@toggle/toggle';
import React from 'react';

import * as S from './CompanyCell.styles';

export interface CompanyCellProps {
  entity: MappedEntity;
}

export const CompanyCell = ({ entity }: CompanyCellProps) => {
  return (
    <WithNAFallback
      value={
        entity && (
          <S.TickerWrapper>
            <AssetLogo entity={entity} isDarkTheme size={20} />
            <S.Ticker>{formatTicker(entity)}</S.Ticker>
          </S.TickerWrapper>
        )
      }
    />
  );
};
